module.exports = __webpack_public_path__ + "img/wifi.a7e48cbf.svg";